import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {createRouterTabGroupTransitionsFor} from './router-tab-group.transitions';
import {Store} from '@ngrx/store';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {MatTabLink, MatTabNav, MatTabNavPanel} from '@angular/material/tabs';
import {RouterOutlet} from '@angular/router';
import {ROUTER_TABS_FOR} from '@app/app.routes';
import {RouteName, RouterTab, RouterTabs, TabbedRouteName} from '@app/app.route-names.generated';

import {ActiveRouterTabActions, QueryParamsSelectors, RouterSelectors} from '@store/aviary/aviary.adapter';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';

@Component({
  selector: 'px-router-tab-group',
  templateUrl: './router-tab-group.component.html',
  animations: [createRouterTabGroupTransitionsFor('100%')],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, MatTabNav, MatTabNavPanel, RouterOutlet, MatTabLink, NamedRouterLinkDirective]
})
export class RouterTabGroupComponent {

  @Input({required: true}) public set tabbedRouteName(routeName: TabbedRouteName) {
    this.tabs = ROUTER_TABS_FOR[routeName];
  }
  @Input() public disabledTabs: RouteName[] = [];

  /**
   * Optional, defaults to 31.25rem.  Minimum height that is used to keep the tab group from collapsing during enter/leave transitions, without forcing us to
   * use 'fixed' positioning, which causes container-escaping layout issues that are more visible in Phoenix.
   */
  @Input() public minHeightRem: number = 31.25;

  public readonly routerSelectors = RouterSelectors;
  public readonly queryParamsSelectors = QueryParamsSelectors;
  public tabs: RouterTabs = [];

  private readonly store: Store = inject(Store);

  public onClick(tab: RouterTab): void {
    this.store.dispatch(ActiveRouterTabActions.save(tab.parentRouteName, tab.routeName));
  }

  public isDisabled(tab: RouterTab): boolean {
    return this.disabledTabs.includes(tab.routeName)
  }
}
